import axios from "axios"

const API_URL = process.env.REACT_APP_API_ENDPOINT

export default function Ajax({ url, ...props }) {
  const options = {
    url: `${API_URL}/${url}`,
    headers: { "Content-Type": "application/json" },
    ...props,
  }

  return axios(options)
}
